import React, { Component } from 'react';
import DateTime from 'react-datetime';
import jQuery from 'jquery';

import './../../../node_modules/react-datetime/css/react-datetime.css';

import Core from '../../Core/Core';

class ExportStatsModal extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            start: 0,
            end: new Date().getTime() / 1000,
        };

        //start date
        var x = new Date();
        x.setDate(1);
        x.setMonth(x.getMonth()-1);
        this.state.start = x.getTime() / 1000;

        this.handleDate = this.handleDate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submit = this.submit.bind(this);
        this.DateTimeStart = React.createRef();
        this.DateTimeEnd = React.createRef();
    }
    
    handleDate(ref, name, date) {
        if (date._isAMomentObject != null) {
          let evt = {
            target: {
              name: name,
              value: date.unix()
            },
          };
          this.handleChange(evt);
        } else if(date === ""){
          let evt = {
            target: {
              name: name,
              value: null
            },
          };
          this.handleChange(evt);
        }
    }

    handleChange(event)
    {
        this.setState({
            [event.target.name]:  event.target.value
        });
    }

    async submit()
    {   
        let address = Core.Address+"ExportUserStats?start_date="+this.state.start+"&end_date="+this.state.end;

        let options = {
            method: "GET",
            mode: "cors",
        };

        if(address.indexOf(Core.Address) != -1)
        {
            let token = Core.Instance.user != null ? Core.Instance.user.token : null;
            if(options.headers == null)
                options.headers =  { 'X-Authorization': "Token "+token };
            else 
                options.headers['X-Authorization'] = "Token "+token;
        }

        let chunks = [];
        let response = await fetch(address, options);
        const reader = response.body.getReader();
        const contentLength = response.headers.get('Content-Length');

        let receivedLength = 0;
        while(true) {
            const {done, value} = await reader.read();
            if (done) {
                break;//Sortie de la boucle
            }
            chunks.push(value);
        }

        let blob = new Blob(chunks);

        // Create blob link to download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'export.csv');
        //Append to html page
        document.body.appendChild(link);
        //Force download
        
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
    }

    render()
    {
        return (
            <div className="modal fade" id="user-stats" tabIndex="-1" role="dialog" aria-labelledby="#userStatsTitle" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header bg-light">
                            <h4 className='modal-title text-uppercase ' id='exportModaltTitle'>
                                Exporter les stats
                            </h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mx-2 row">
                                <span className='my-auto'>Du :</span>
                                <div className='mr-2' ref={this.DateTimeStart} style={{ width: '110px' }}>
                                    <DateTime
                                        name='date'
                                        timeFormat={false}
                                        onChange={(date) => {
                                        this.handleDate(this.DateTimeStart, 'start', date);
                                        }}
                                        dateFormat='DD/MM/YYYY'
                                        locale='fr'
                                        value={this.state.start != null ? this.state.start * 1000 : null}
                                        closeOnSelect={true}
                                    />
                                </div>
                                <span className='my-auto'>au :</span>
                                <div className='mr-2' ref={this.DateTimeEnd} style={{ width: '110px' }}>
                                    <DateTime
                                        name='date'
                                        timeFormat={false}
                                        onChange={(date) => {
                                        this.handleDate(this.DateTimeEnd, 'end', date);
                                        }}
                                        dateFormat='DD/MM/YYYY'
                                        locale='fr'
                                        value={this.state.end!= null ? this.state.end * 1000 : null}
                                        closeOnSelect={true}
                                    />
                                </div>
                            </div>                       
                        </div>
                        <div className='modal-footer'>
                            <button type='button' className='btn btn-primary text-center mx-auto' onClick={() => this.submit()}>
                                Lancer l'export
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }
}

export default ExportStatsModal;



// WEBPACK FOOTER //
// ./src/Components/User/ExportStatsModal.js